<div class="container" style="padding-top: 50px;">
    <div class="row justify-content-between services">
        <div class="col-lg-5">
            <div class="services-hero">
                <span class="services-hero__eyebrow">Services</span>

                <h2 class="services-hero__title">
                    Get a robust software solution that delivers
                    <span class="services-hero__accent">outstanding performance</span>
                    with an all-in-one toolkit.
                </h2>

                <p class="services-hero__subtitle">
                    I build reliable, scalable products end-to-end — from architecture to delivery.
                </p>
            </div>

            <div class="feature-card feature-card--compact">
                <div class="feature-card__icon">
                    <i class="bi-key-fill"></i>
                </div>

                <div class="feature-card__content">
                    <h5 class="feature-card__title">Key Strengths</h5>

                    <ul class="tag-list">
                        <li class="tag">Teamwork & Collaboration</li>
                        <li class="tag">Problem-Solving</li>
                        <li class="tag">Adaptability</li>
                        <li class="tag">Communication</li>
                        <li class="tag">Time Management</li>
                        <li class="tag">Empathy & Interpersonal Skills</li>
                        <li class="tag">Leadership</li>
                    </ul>
                </div>
            </div>

            <div class="feature-card feature-card--compact">
                <div class="feature-card__icon">
                    <i class="bi-pen-fill"></i>
                </div>

                <div class="feature-card__content">
                    <h5 class="feature-card__title">Language Portfolio</h5>

                    <div class="lang-list">
                        <div class="lang">
                            <span class="lang__name">English</span>
                            <span class="lang__dots" aria-label="Level 5 out of 5">
                                <i class="bi bi-check-circle-fill"></i>
                                <i class="bi bi-check-circle-fill"></i>
                                <i class="bi bi-check-circle-fill"></i>
                                <i class="bi bi-check-circle-fill"></i>
                                <i class="bi bi-check-circle-fill"></i>
                            </span>
                        </div>

                        <div class="lang">
                            <span class="lang__name">German</span>
                            <span class="lang__dots" aria-label="Level 5 out of 5">
                                <i class="bi bi-check-circle-fill"></i>
                                <i class="bi bi-check-circle-fill"></i>
                                <i class="bi bi-check-circle-fill"></i>
                                <i class="bi bi-check-circle-fill"></i>
                                <i class="bi bi-check-circle-fill"></i>
                            </span>
                        </div>

                        <div class="lang">
                            <span class="lang__name">Albanian</span>
                            <span class="lang__dots" aria-label="Level 5 out of 5">
                                <i class="bi bi-check-circle-fill"></i>
                                <i class="bi bi-check-circle-fill"></i>
                                <i class="bi bi-check-circle-fill"></i>
                                <i class="bi bi-check-circle-fill"></i>
                                <i class="bi bi-check-circle-fill"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-6 services__right">
            <div class="feature-card feature-card--service">
                <div class="feature-card__icon">
                    <i class="bi-code-square"></i>
                </div>

                <div class="feature-card__content">
                    <h5 class="feature-card__title">Software Development</h5>
                    <p class="feature-card__text">
                        From idea to production: clean code, testing, and smooth deployments — delivered as one coherent
                        solution.
                    </p>
                </div>
            </div>

            <div class="feature-card feature-card--service">
                <div class="feature-card__icon">
                    <i class="bi-code"></i>
                </div>

                <div class="feature-card__content">
                    <h5 class="feature-card__title">API & Backend Development</h5>
                    <p class="feature-card__text">
                        Secure, well-structured APIs with solid database design and integrations that scale with your
                        product.
                    </p>
                </div>
            </div>

            <div class="feature-card feature-card--service">
                <div class="feature-card__icon">
                    <i class="bi-hammer"></i>
                </div>

                <div class="feature-card__content">
                    <h5 class="feature-card__title">System Architecture</h5>
                    <p class="feature-card__text">
                        Pragmatic architecture for maintainability and performance — services, integration patterns, and
                        scalability.
                    </p>
                </div>
            </div>

            <div class="feature-card feature-card--service">
                <div class="feature-card__icon">
                    <i class="bi-speedometer2"></i>
                </div>

                <div class="feature-card__content">
                    <h5 class="feature-card__title">Performance Optimization</h5>
                    <p class="feature-card__text">
                        Faster UX and leaner systems using profiling, caching, server tuning, and data-driven
                        improvements.
                    </p>
                </div>
            </div>
        </div>
    </div>
    <div class="row gx-0" class="tech-arsenal-section">
        <div class="project-box gy-5" style="background-image: url(assets/img/project-1.jpg);">
            <section class="tech-arsenal">
                <h2 class="tech-title">Tech Stack Arsenal</h2>

                <div class="tech-grid">
                    <article class="tech-card" *ngFor="let group of techGroups">
                        <header class="tech-card__header">
                            <h3 class="tech-card__title">{{ group.title }}</h3>

                            <!-- <button class="tech-copy" type="button" (click)="copy(group)" aria-label="Copy tech stack">
                                <i class="bi bi-copy"></i>
                            </button> -->
                        </header>

                        <ul class="tech-list">
                            <li class="tech-item" *ngFor="let tech of group.items">
                                <span class="tech-name">{{ tech.name }}</span>
                                <img class="tech-icon" [src]="tech.icon" [alt]="tech.name" loading="lazy" />
                            </li>
                        </ul>
                    </article>
                </div>
            </section>
        </div>
    </div>
    <!-- <div class="btn-bar mt-4">
        <a class="px-btn dark" href="#contactus"><span>Get in touch</span> <i class="bi-arrow-right"></i> </a>
    </div> -->
</div>